import { jsx as r, jsxs as A } from "react/jsx-runtime";
import { useState as H, useRef as le, useEffect as K, useCallback as F, useMemo as b, memo as Pt, useContext as Bt } from "react";
import { useNavigate as Ke, useSearch as At } from "@tanstack/react-router";
import { b as De, u as Pe, c as Z, a as Rt, E as Ie, d as xt } from "./use-definition-0yWcQDPI.js";
import { M as Et, N as kt, O as $t, P as qt, K as ke, b as et, u as Ft, Q as Mt, L as Vt } from "./FormView-CWSNCHG6.js";
import { Select as ct, Input as Le, Flex as g, Checkbox as Ve, Typography as D, Button as ue, Modal as jt, Radio as $e, Alert as it, Collapse as Kt, Spin as Ht } from "antd";
import { i as dt, u as zt, e as Gt, d as Wt, h as Ut, r as Yt, D as Qt, s as tt, g as Jt, f as Xt } from "./DataGrid-Cy1qOpyR.js";
import { HolderOutlined as Zt, DownloadOutlined as Dt, SearchOutlined as qe, ReloadOutlined as rt, LayoutOutlined as er, FilterOutlined as tr, SettingOutlined as rr, CloseOutlined as nr } from "@ant-design/icons";
import { useSensors as or, useSensor as sr, PointerSensor as lr, DndContext as ar, closestCenter as cr } from "@dnd-kit/core";
import { useSortable as ir, SortableContext as dr, verticalListSortingStrategy as ur } from "@dnd-kit/sortable";
import { h as je, g as mr, i as pr, r as Fe, a as fr, j as nt, k as ot } from "./templateResolver-BchYA4i9.js";
import { z as hr } from "./fetcher-CUYp7JR1.js";
import "idb";
import { CSS as gr } from "@dnd-kit/utilities";
const br = 700;
function Sr(t, l, n = br) {
  const [u, i] = H(t), c = le(null), S = le(t), N = le(l);
  N.current = l, K(() => {
    t !== S.current && (S.current = t, i(t));
  }, [t]), K(
    () => () => {
      c.current && clearTimeout(c.current);
    },
    []
  );
  const P = F(
    (w) => {
      const _ = w.target.value;
      i(_), c.current && (clearTimeout(c.current), c.current = null);
      const d = () => {
        S.current = _, N.current(_);
      };
      if (_ === "") {
        d();
        return;
      }
      c.current = setTimeout(d, n);
    },
    [n]
  );
  return { inputValue: u, onChange: P };
}
const _r = "_filterSelectShell_12mb4_2", vr = "_filterInput_12mb4_32", yr = "_filterSelectDropdown_12mb4_45", _e = {
  filterSelectShell: _r,
  filterInput: vr,
  filterSelectDropdown: yr
}, Cr = 300;
function Tr(t) {
  let l = [];
  if (Array.isArray(t))
    l = t;
  else if (t !== null && typeof t == "object" && "data" in t) {
    const n = t.data;
    Array.isArray(n) && (l = n);
  }
  return l.filter(
    (n) => n !== null && typeof n == "object" && !Array.isArray(n)
  );
}
function st(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "bigint" ? String(t) : "";
}
function lt(t, l, n, u) {
  return Tr(t).map((i) => {
    const c = i[n], S = st(c);
    if (!S)
      return null;
    const N = i[l];
    return {
      label: (u ? dt(u, i).trim() : st(N ?? "")) || S,
      value: S
    };
  }).filter((i) => i !== null);
}
function wr(t, l) {
  if (!t)
    return;
  const n = t.indexOf(":"), u = n === -1 ? t : t.slice(n + 1);
  if (u) {
    if (l) {
      const i = u.split(",").map((c) => c.trim()).filter(Boolean);
      return i.length > 0 ? i : void 0;
    }
    return u;
  }
}
function Nr(t, l) {
  if (t == null)
    return "";
  if (l) {
    const i = (Array.isArray(t) ? t : [t]).map(String).filter(Boolean);
    return i.length === 0 ? "" : `in:${i.join(",")}`;
  }
  const n = Array.isArray(t) ? t[0] : t;
  return n ? `eq:${n}` : "";
}
const Or = ({
  entity: t,
  valueField: l,
  labelField: n = "name",
  nameTemplate: u,
  multiple: i = !1,
  value: c,
  placeholder: S = "Search to select...",
  onChange: N
}) => {
  const [P, w] = H(""), [_, d] = H(
    {}
  ), v = le(null);
  K(
    () => () => {
      v.current && clearTimeout(v.current);
    },
    []
  );
  const m = b(
    () => wr(c, i),
    [c, i]
  ), U = b(() => {
    const s = P ? `&_search=${encodeURIComponent(P)}` : "";
    return `/${t}/list?limit=50${s}`;
  }, [t, P]), [O] = De(U), z = b(() => {
    if (m === void 0)
      return null;
    const s = Array.isArray(m) ? m : [m];
    return s.length === 0 ? null : `/${t}/list?limit=${s.length}&_${l}=in:${s.join(",")}`;
  }, [t, m, l]), [$] = De(z), q = b(() => {
    const s = lt(
      O.data,
      n,
      l,
      u
    ), I = lt(
      $.data,
      n,
      l,
      u
    ), T = new Set(I.map((L) => L.value)), f = [...I];
    for (const L of s)
      T.has(L.value) || f.push(L);
    return f;
  }, [
    O.data,
    $.data,
    n,
    l,
    u
  ]);
  K(() => {
    q.length !== 0 && d((s) => {
      const I = { ...s };
      let T = !1;
      for (const f of q)
        I[f.value] !== f.label && (I[f.value] = f.label, T = !0);
      return T ? I : s;
    });
  }, [q]);
  const M = b(() => {
    if (m === void 0)
      return q;
    const s = Array.isArray(m) ? m : [m], I = new Map(q.map((T) => [T.value, T]));
    for (const T of s)
      I.has(T) || I.set(T, {
        value: T,
        label: _[T] || T
      });
    return [...I.values()];
  }, [q, m, _]), y = F((s) => {
    v.current && clearTimeout(v.current), v.current = setTimeout(() => {
      w(s.trim());
    }, Cr);
  }, []), R = F(
    (s) => {
      const I = Array.isArray(s) ? s : s ? [s] : [];
      I.length > 0 && d((T) => {
        const f = { ...T };
        for (const L of I) {
          const X = M.find(
            (j) => j.value === L
          );
          X && (f[L] = X.label);
        }
        return f;
      }), N(Nr(s, i)), w("");
    },
    [M, i, N]
  );
  return /* @__PURE__ */ r("div", { className: _e.filterSelectShell, children: /* @__PURE__ */ r(
    ct,
    {
      allowClear: !0,
      showSearch: {
        filterOption: !1,
        onSearch: y
      },
      size: "small",
      mode: i ? "multiple" : void 0,
      placeholder: S,
      value: m,
      options: M,
      optionLabelProp: "label",
      onChange: R,
      classNames: { popup: { root: _e.filterSelectDropdown } },
      getPopupContainer: () => document.body,
      style: { width: "100%" },
      variant: "borderless",
      notFoundContent: O.isFetching || $.isFetching ? "Loading..." : "No results"
    }
  ) });
};
function Ir(t) {
  if (!Array.isArray(t))
    return null;
  const l = [];
  for (const n of t) {
    if (typeof n == "string" || typeof n == "number") {
      const u = String(n);
      l.push({ label: u, value: u });
      continue;
    }
    if (n && typeof n == "object" && "value" in n && (typeof n.value == "string" || typeof n.value == "number")) {
      const u = String(n.value), i = n.label;
      l.push({
        label: typeof i == "string" || typeof i == "number" ? String(i) : u,
        value: u
      });
    }
  }
  return l.length > 0 ? l : null;
}
const Lr = ({
  fieldID: t,
  label: l,
  columnDef: n,
  value: u = "",
  onChange: i
}) => {
  var P, w, _;
  const c = Pe().data;
  if ((n == null ? void 0 : n.type) === "relation" && !!n.target && (n != null && n.target)) {
    const d = c == null ? void 0 : c[n.target], v = n.joinColumn || n.referencedColumn || "id", m = typeof ((P = d == null ? void 0 : d.ui) == null ? void 0 : P.nameTemplate) == "string" ? d.ui.nameTemplate : "{name}";
    return /* @__PURE__ */ r(
      Or,
      {
        entity: n.target,
        valueField: v,
        labelField: "name",
        nameTemplate: m,
        multiple: !!((w = n.ui) != null && w.multiple),
        value: u,
        placeholder: `Filter by ${l}`,
        onChange: i
      }
    );
  }
  const N = Ir((_ = n == null ? void 0 : n.ui) == null ? void 0 : _.options);
  if (N) {
    const d = u.indexOf(":"), v = d === -1 ? u : u.slice(d + 1) || void 0;
    return /* @__PURE__ */ r("div", { className: _e.filterSelectShell, children: /* @__PURE__ */ r(
      ct,
      {
        allowClear: !0,
        showSearch: {
          optionFilterProp: "label"
        },
        size: "small",
        placeholder: `Filter by ${l}`,
        value: v || void 0,
        options: N,
        optionLabelProp: "label",
        onChange: (m) => {
          i(
            m == null || m === "" ? "" : `eq:${m}`
          );
        },
        classNames: {
          popup: { root: _e.filterSelectDropdown }
        },
        getPopupContainer: () => document.body,
        style: { width: "100%" },
        variant: "borderless"
      }
    ) });
  }
  return /* @__PURE__ */ r(
    Le,
    {
      allowClear: !0,
      size: "small",
      placeholder: `Filter by ${l}`,
      value: u,
      onChange: (d) => {
        i(d.target.value);
      },
      className: _e.filterInput
    }
  );
}, Pr = "_tableWrapper_1lpq2_1", Br = "_topSearchArea_1lpq2_10", Ar = "_searchBar_1lpq2_14", Rr = "_refreshBtn_1lpq2_56", xr = "_tableActions_1lpq2_65", Er = "_selectedCount_1lpq2_72", kr = "_container_1lpq2_77", $r = "_tableLayout_1lpq2_85", qr = "_gridArea_1lpq2_95", Fr = "_rightTabsBar_1lpq2_106", Mr = "_tabItem_1lpq2_118", Vr = "_activeTab_1lpq2_139", jr = "_tabIcon_1lpq2_139", Kr = "_filtersSidebar_1lpq2_143", Hr = "_columnsSidebar_1lpq2_153", zr = "_columnsBody_1lpq2_163", Gr = "_columnsToolbar_1lpq2_173", Wr = "_columnsMasterCheckbox_1lpq2_181", Ur = "_columnPanelCheckbox_1lpq2_186", Yr = "_columnsSearch_1lpq2_251", Qr = "_columnsList_1lpq2_257", Jr = "_columnOption_1lpq2_269", Xr = "_columnDragHandle_1lpq2_278", Zr = "_columnLabel_1lpq2_294", Dr = "_filtersToolbar_1lpq2_310", en = "_filtersSearch_1lpq2_317", tn = "_filtersCollapseScroll_1lpq2_322", rn = "_filtersBody_1lpq2_333", nn = "_tabText_1lpq2_364", on = "_loadingWrap_1lpq2_372", sn = "_sidePanel_1lpq2_378", ln = "_sidePanelHeader_1lpq2_388", an = "_sidePanelBody_1lpq2_393", a = {
  tableWrapper: Pr,
  topSearchArea: Br,
  searchBar: Ar,
  refreshBtn: Rr,
  tableActions: xr,
  selectedCount: Er,
  container: kr,
  tableLayout: $r,
  gridArea: qr,
  rightTabsBar: Fr,
  tabItem: Mr,
  activeTab: Vr,
  tabIcon: jr,
  filtersSidebar: Kr,
  columnsSidebar: Hr,
  columnsBody: zr,
  columnsToolbar: Gr,
  columnsMasterCheckbox: Wr,
  columnPanelCheckbox: Ur,
  columnsSearch: Yr,
  columnsList: Qr,
  columnOption: Jr,
  columnDragHandle: Xr,
  columnLabel: Zr,
  filtersToolbar: Dr,
  filtersSearch: en,
  filtersCollapseScroll: tn,
  filtersBody: rn,
  tabText: nn,
  loadingWrap: on,
  sidePanel: sn,
  sidePanelHeader: ln,
  sidePanelBody: an
}, cn = ({
  columnID: t,
  label: l,
  checked: n,
  onToggle: u
}) => {
  const {
    attributes: i,
    listeners: c,
    setNodeRef: S,
    transform: N,
    transition: P,
    isDragging: w
  } = ir({ id: t }), _ = {
    transform: gr.Transform.toString(N),
    transition: P,
    opacity: w ? 0.85 : 1
  };
  return /* @__PURE__ */ A(
    g,
    {
      ref: S,
      style: _,
      align: "center",
      gap: 8,
      className: a.columnOption,
      children: [
        /* @__PURE__ */ r(
          g,
          {
            align: "center",
            justify: "center",
            className: a.columnDragHandle,
            ...i,
            ...c,
            role: "button",
            tabIndex: 0,
            "aria-label": `Drag ${l} column`,
            children: /* @__PURE__ */ r(Zt, { "aria-hidden": !0 })
          }
        ),
        /* @__PURE__ */ r(
          Ve,
          {
            className: a.columnPanelCheckbox,
            checked: n,
            onChange: u,
            "aria-label": l
          }
        ),
        /* @__PURE__ */ r(D.Text, { className: a.columnLabel, children: l })
      ]
    }
  );
}, dn = "_modal_1duji_1", un = "_optionGroup_1duji_25", at = {
  modal: dn,
  optionGroup: un
};
function mn({
  entity: t,
  entityDef: l,
  entityColOverride: n,
  allDefinitions: u,
  visibleColumnKeys: i,
  currentPageRows: c,
  pagination: S,
  listExportParams: N,
  csvFilename: P,
  enabled: w = !1
}) {
  const [_, d] = H(!1), [v, m] = H("current-page"), [U, O] = H(!1), [z, $] = H(null), q = zt({
    entityDef: l,
    entityColOverride: n,
    allDefinitions: u,
    visibleColumnKeys: i,
    includeActionsColumn: !1
  }), M = b(
    () => q.filter((f) => f.key !== "_actions").map((f) => ({
      key: String(f.dataIndex ?? f.key),
      title: String(f.title ?? f.key),
      render: f.render ? (L, X) => {
        var j;
        return (j = f.render) == null ? void 0 : j.call(f, L, X);
      } : void 0
    })),
    [q]
  ), y = w && M.length > 0, R = F(async () => {
    if (M.length !== 0) {
      O(!0), $(null);
      try {
        const f = v === "current-page" ? c : await Et(t, {
          ...N ?? {},
          limit: (N == null ? void 0 : N.limit) ?? (S == null ? void 0 : S.limit) ?? 100
        });
        if (f.length === 0) {
          $("No rows available to export.");
          return;
        }
        const L = kt(f, M);
        $t(
          L,
          P ?? qt(t)
        ), d(!1);
      } catch (f) {
        $(
          f instanceof Error ? f.message : "Failed to export CSV."
        );
      } finally {
        O(!1);
      }
    }
  }, [
    v,
    P,
    c,
    t,
    M,
    N,
    S == null ? void 0 : S.limit
  ]), s = F(() => {
    m("current-page"), $(null), d(!0);
  }, []), I = y ? /* @__PURE__ */ r(ue, { icon: /* @__PURE__ */ r(Dt, {}), onClick: s, children: "Download CSV" }) : null, T = y ? /* @__PURE__ */ r(
    jt,
    {
      title: "Download CSV",
      open: _,
      centered: !0,
      width: 380,
      className: at.modal,
      onCancel: () => {
        U || (d(!1), $(null));
      },
      onOk: () => {
        R();
      },
      okText: "Download",
      confirmLoading: U,
      destroyOnClose: !0,
      children: /* @__PURE__ */ A(g, { vertical: !0, gap: 10, children: [
        /* @__PURE__ */ r(D.Text, { type: "secondary", children: "Choose which rows to include in the CSV file." }),
        /* @__PURE__ */ A(
          $e.Group,
          {
            className: at.optionGroup,
            value: v,
            onChange: (f) => {
              m(f.target.value), $(null);
            },
            children: [
              /* @__PURE__ */ A($e, { value: "current-page", children: [
                "Current page only (Page ",
                (S == null ? void 0 : S.page) ?? 1,
                ",",
                " ",
                c.length,
                " row",
                c.length === 1 ? "" : "s",
                ")"
              ] }),
              /* @__PURE__ */ r($e, { value: "all-pages", children: "All pages (uses current filters and sort)" })
            ]
          }
        ),
        z && /* @__PURE__ */ r(it, { type: "error", message: z, showIcon: !0 })
      ] })
    }
  ) : null;
  return {
    csvExportButton: I,
    csvExportModal: T,
    canExport: y
  };
}
const pn = {}, fn = [], ut = Pt(
  ({
    entity: t,
    scope: l,
    entityColOverride: n,
    customColumnDefs: u,
    customColumnDefsPosition: i,
    tableData: c,
    onRowClick: S,
    getRowContextMenuItems: N,
    entityDefOverride: P,
    filters: w = {},
    onFilterChange: _,
    sorting: d = Ie,
    onSortChange: v,
    refresh: m,
    loading: U,
    onAddNew: O,
    showEditButton: z = !0,
    rowSelectionMode: $,
    tableActions: q,
    enableCsvExport: M,
    toolbarExtra: y
  }) => {
    var Ze;
    const R = Ke(), s = At({ strict: !1 }), I = !!s.mode, [T, f] = H(null), [L, X] = H(
      null
    ), [j, Y] = H(
      []
    ), [Q, ne] = H(""), [ae, oe] = H(""), [me, pe] = H({}), x = b(
      () => `table-view:${t}`,
      [t]
    ), fe = le(!1), ce = le(!1), te = le(!1), re = Z(
      (e) => {
        var o;
        return (o = e.tablePreferencesByKey[x]) == null ? void 0 : o.columns.visibility;
      }
    ), h = Z(
      (e) => {
        var o;
        return ((o = e.tablePreferencesByKey[x]) == null ? void 0 : o.columns.order) ?? fn;
      }
    ), G = Z(
      (e) => {
        var o;
        return ((o = e.tablePreferencesByKey[x]) == null ? void 0 : o.columns.customized) === !0;
      }
    ), ie = Z(
      (e) => {
        var o;
        return ((o = e.tablePreferencesByKey[x]) == null ? void 0 : o.filters) ?? pn;
      }
    ), ve = Z(
      (e) => e.saveColumnLayout
    ), ye = Z(
      (e) => e.clearColumnLayout
    ), Be = Z(
      (e) => e.setFilters
    ), Ae = Z(
      (e) => e.setSorting
    ), He = Z(
      (e) => e.clearTablePreference
    ), ze = je(
      (e) => e.getActiveRecord
    ), J = je(
      (e) => e.setActiveRecord
    ), Ge = Pe(), E = P ?? Ge.data[t], mt = Ge.data, pt = b(
      () => Gt(E),
      [E]
    ), ft = mr(E), he = pr(E), Ce = fr(ft), We = s.id ?? null, Re = b(() => s.mode ? ke(
      t,
      Fe(
        s.mode,
        he
      )
    ) : "read", [t, he, s.mode]), [Te] = Rt(t, We, {
      enabled: !!We && !T
    });
    K(() => {
      Te.data && !T && f(Te.data);
    }, [Te.data, T]);
    const ht = F(
      (e) => {
        if (S)
          S(e);
        else {
          const o = l ?? t, C = ke(
            t,
            Fe(
              Ce,
              he
            )
          );
          J(o, {
            id: String(e.id),
            mode: C
          }), f(e), R({
            to: ".",
            search: {
              mode: C,
              id: e.id
            }
          });
        }
      },
      [
        R,
        S,
        l,
        t,
        J,
        Ce
      ]
    );
    K(() => {
      if (!s.id || !s.mode) return;
      const e = ke(
        t,
        Fe(
          s.mode,
          he
        )
      );
      e !== s.mode && R({
        to: ".",
        search: {
          mode: e,
          id: s.id
        }
      });
    }, [t, he, R, s.id, s.mode]);
    const de = (Ze = c == null ? void 0 : c.data) == null ? void 0 : Ze.data, Ue = M !== !1 && !!(c != null && c.listParams);
    K(() => {
      pe({});
    }, [de]);
    const we = b(() => Array.isArray(de) ? de.filter((e, o) => {
      const C = Wt(e, o);
      return me[C];
    }) : [], [de, me]), Ye = b(
      () => ({
        selectedRows: we,
        filters: w
      }),
      [we, w]
    ), gt = !I && (!!_ || !!$ || !!(q != null && q.length) || !!O || Ue || m !== void 0 || !!y), Ne = F(() => {
      s.mode === "create" ? nt(t, "create", "new") : s.id && nt(t, "edit", s.id), R({
        to: ".",
        search: {}
      }), J(l ?? t, null), f(null);
    }, [R, l, t, J, s.mode, s.id]);
    K(() => {
      if (!s.mode) return;
      const e = l ?? t;
      if (s.mode === "create") {
        J(e, { mode: "create" });
        return;
      }
      s.id && J(e, {
        id: s.id,
        mode: s.mode
      });
    }, [s.mode, s.id, l, t, J]), K(() => {
      if (I) return;
      const o = ze(l ?? t);
      if (o) {
        if (o.mode === "create") {
          R({
            to: ".",
            search: {
              mode: "create"
            }
          });
          return;
        }
        o.id && R({
          to: ".",
          search: {
            mode: o.mode,
            id: o.id
          }
        });
      }
    }, [t, ze, I, R, l]);
    const xe = F(
      (e, o) => {
        const C = { ...w, [e]: o };
        Be(x, C), _ && _(C);
      },
      [w, _, Be, x]
    ), bt = F(
      (e) => {
        xe("search", e);
      },
      [xe]
    ), { inputValue: St, onChange: _t } = Sr(
      String(w.search ?? ""),
      bt
    ), vt = F(
      (e) => {
        Ae(x, e), v == null || v(e);
      },
      [v, Ae, x]
    ), Qe = b(() => {
      var o, C;
      return (((C = (o = E == null ? void 0 : E.ui) == null ? void 0 : o.table) == null ? void 0 : C.filters) || []).map((B) => {
        var V, se;
        const k = (V = E == null ? void 0 : E.columns) == null ? void 0 : V[B];
        return {
          id: B,
          label: ((se = k == null ? void 0 : k.ui) == null ? void 0 : se.label) || B,
          type: k == null ? void 0 : k.type,
          columnDef: k
        };
      });
    }, [E]), yt = b(() => {
      const e = ae.trim().toLowerCase();
      return Qe.filter(
        (o) => e === "" ? !0 : o.label.toLowerCase().includes(e)
      );
    }, [Qe, ae]), Oe = b(
      () => {
        var e, o;
        return (((o = (e = E == null ? void 0 : E.ui) == null ? void 0 : e.table) == null ? void 0 : o.columns) || []).filter(
          (C) => C in ((E == null ? void 0 : E.columns) || {})
        ).map((C) => {
          var B, k;
          return {
            id: C,
            label: ((k = (B = E.columns[C]) == null ? void 0 : B.ui) == null ? void 0 : k.label) || C
          };
        });
      },
      [E]
    ), p = b(
      () => Oe.map((e) => e.id),
      [Oe]
    );
    K(() => {
      fe.current = !1, ce.current = !1, te.current = !1, Y([]);
    }, [x]), K(() => {
      if (p.length === 0) {
        Y([]);
        return;
      }
      if (!G) {
        ye(x), Y([...p]), ce.current = !0;
        return;
      }
      const e = re ?? {}, o = new Set(p), B = [
        ...h.filter((k) => o.has(k)),
        ...p.filter(
          (k) => !h.includes(k)
        )
      ].filter(
        (k) => e[k]
      );
      Y(
        B.length > 0 ? B : [...p]
      ), ce.current = !0;
    }, [
      ye,
      p,
      h,
      re,
      G,
      x
    ]);
    const ee = b(() => p.length === 0 ? [] : j.filter(
      (e) => p.includes(e)
    ), [p, j]), W = b(() => p.length === 0 ? [] : j.length === 0 || ee.length === 0 ? [...p] : j.filter(
      (e) => p.includes(e)
    ), [
      p,
      j,
      ee.length
    ]), ge = b(
      () => Ut(
        W,
        p
      ),
      [W, p]
    ), Ee = F(
      (e) => {
        te.current = !0;
        const o = e.filter(
          (C) => p.includes(C)
        );
        Y(o);
      },
      [p]
    ), Ct = or(
      sr(lr, {
        activationConstraint: { distance: 8 }
      })
    ), Tt = Q.trim() === "", Je = b(() => {
      const e = new Map(
        Oe.map((B) => [
          B.id,
          B.label
        ])
      ), o = Q.trim().toLowerCase(), C = ge.map((B) => ({
        id: B,
        label: e.get(B) ?? B
      }));
      return o === "" ? C : C.filter(
        (B) => B.label.toLowerCase().includes(o)
      );
    }, [Oe, Q, ge]), wt = F(
      (e) => {
        const { active: o, over: C } = e;
        if (!C)
          return;
        const k = Yt(
          ge,
          String(o.id),
          String(C.id)
        ).filter(
          (V) => W.includes(V)
        );
        k.join("|") !== W.join("|") && Ee(k);
      },
      [
        Ee,
        ge,
        W
      ]
    ), { csvExportButton: Nt, csvExportModal: Ot } = mn({
      entity: t,
      entityDef: E,
      entityColOverride: n,
      allDefinitions: mt,
      visibleColumnKeys: W,
      currentPageRows: Array.isArray(de) ? de : [],
      pagination: c == null ? void 0 : c.pagination,
      listExportParams: c == null ? void 0 : c.listParams,
      enabled: Ue
    }), be = b(() => p.length === 0 ? [] : ee.length === 0 ? [...p] : ee, [p, ee]), Se = b(
      () => p.length > 0 && be.length === p.length && p.every(
        (e) => be.includes(e)
      ),
      [p, be]
    ), It = b(
      () => p.length > 0 && !Se && be.length > 0,
      [
        Se,
        p.length,
        be.length
      ]
    ), Lt = F(() => {
      if (p.length !== 0) {
        if (te.current = !0, Se) {
          Y([p[0]]);
          return;
        }
        Y([...p]);
      }
    }, [Se, p]), Xe = F((e) => {
      te.current = !0, Y((o) => o.includes(e) ? o.length === 1 ? o : o.filter((C) => C !== e) : [...o, e]);
    }, []);
    return K(() => {
      !_ || fe.current || (fe.current = !0, !(Object.keys(w).length > 0 || Object.keys(ie).length === 0) && _(ie));
    }, [w, _, ie]), K(() => {
      if (!te.current || p.length === 0 || !ce.current || ee.length === 0 || j.some(
        (V) => !p.includes(V)
      ))
        return;
      const o = p.reduce(
        (V, se) => ({
          ...V,
          [se]: W.includes(se)
        }),
        {}
      ), C = p.filter(
        (V) => !W.includes(V)
      ), B = [
        ...W,
        ...C
      ];
      (!G || p.some(
        (V) => (re == null ? void 0 : re[V]) !== o[V]
      ) || h.length !== B.length || h.some(
        (V, se) => V !== B[se]
      )) && ve(x, {
        order: B,
        visibility: o
      });
    }, [
      p,
      W,
      ve,
      h,
      re,
      G,
      x,
      j,
      ee.length
    ]), /* @__PURE__ */ A(g, { vertical: !0, className: a.tableWrapper, children: [
      Ot,
      gt && /* @__PURE__ */ A(
        g,
        {
          align: "center",
          gap: 16,
          className: a.topSearchArea,
          children: [
            _ ? /* @__PURE__ */ r(
              Le,
              {
                prefix: /* @__PURE__ */ r(qe, {}),
                placeholder: "Search...",
                allowClear: !0,
                size: "large",
                className: a.searchBar,
                value: St,
                onChange: _t
              }
            ) : !y && /* @__PURE__ */ r(g, { flex: 1, style: { minWidth: 0 } }),
            typeof y == "function" ? y({
              filters: w,
              onFilterChange: _
            }) : y,
            /* @__PURE__ */ A(g, { align: "center", className: a.tableActions, children: [
              $ && we.length > 0 && /* @__PURE__ */ A(
                D.Text,
                {
                  type: "secondary",
                  className: a.selectedCount,
                  children: [
                    we.length,
                    " selected"
                  ]
                }
              ),
              q == null ? void 0 : q.map((e) => {
                const o = !!U || !e.isEnabled(Ye);
                return /* @__PURE__ */ r(
                  ue,
                  {
                    type: e.type ?? "default",
                    danger: e.danger,
                    icon: e.icon,
                    disabled: o,
                    onClick: () => {
                      e.onClick(Ye);
                    },
                    children: e.label
                  },
                  e.key
                );
              }),
              O && /* @__PURE__ */ r(
                ue,
                {
                  type: "primary",
                  className: "actionCardButton",
                  onClick: O,
                  children: "Add New"
                }
              ),
              Nt,
              m !== void 0 && /* @__PURE__ */ r(
                ue,
                {
                  type: "text",
                  className: a.refreshBtn,
                  icon: /* @__PURE__ */ r(
                    rt,
                    {
                      style: { fontSize: 18 }
                    }
                  ),
                  onClick: m,
                  loading: U
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ A(g, { flex: 1, className: a.container, children: [
        !I && /* @__PURE__ */ A(g, { flex: 1, className: a.tableLayout, children: [
          /* @__PURE__ */ r(g, { flex: 1, vertical: !0, className: a.gridArea, children: /* @__PURE__ */ r(
            Qt,
            {
              entity: t,
              entityColOverride: n,
              customColumnDefs: u,
              customColumnDefsPosition: i,
              gridData: c,
              pagination: c.pagination,
              onRowClick: ht,
              getRowContextMenuItems: N,
              entityDefOverride: P,
              visibleColumnKeys: W,
              tablePreferencesKey: x,
              sortableColumnKeys: pt,
              sorting: d,
              onSortingChange: vt,
              columnOrder: W,
              onColumnOrderChange: Ee,
              ...$ ? {
                rowSelectionMode: $,
                rowSelection: me,
                onRowSelectionChange: pe
              } : {}
            }
          ) }),
          L === "columns" && /* @__PURE__ */ r(
            g,
            {
              vertical: !0,
              className: a.columnsSidebar,
              children: /* @__PURE__ */ A(
                g,
                {
                  vertical: !0,
                  className: a.columnsBody,
                  children: [
                    /* @__PURE__ */ A(
                      g,
                      {
                        align: "center",
                        gap: 8,
                        className: a.columnsToolbar,
                        children: [
                          /* @__PURE__ */ r(
                            Ve,
                            {
                              checked: Se,
                              indeterminate: It,
                              disabled: p.length === 0,
                              onChange: Lt,
                              "aria-label": "Select or clear all columns",
                              className: `${a.columnsMasterCheckbox} ${a.columnPanelCheckbox}`
                            }
                          ),
                          /* @__PURE__ */ r(
                            Le,
                            {
                              allowClear: !0,
                              prefix: /* @__PURE__ */ r(qe, {}),
                              placeholder: "Search columns...",
                              value: Q,
                              onChange: (e) => {
                                ne(
                                  e.target.value
                                );
                              },
                              className: a.columnsSearch
                            }
                          )
                        ]
                      }
                    ),
                    Tt ? /* @__PURE__ */ r(
                      ar,
                      {
                        sensors: Ct,
                        collisionDetection: cr,
                        onDragEnd: wt,
                        children: /* @__PURE__ */ r(
                          dr,
                          {
                            items: ge,
                            strategy: ur,
                            children: /* @__PURE__ */ r(
                              g,
                              {
                                vertical: !0,
                                className: a.columnsList,
                                children: Je.map(
                                  (e) => /* @__PURE__ */ r(
                                    cn,
                                    {
                                      columnID: e.id,
                                      label: e.label,
                                      checked: ee.includes(
                                        e.id
                                      ),
                                      onToggle: () => {
                                        Xe(
                                          e.id
                                        );
                                      }
                                    },
                                    e.id
                                  )
                                )
                              }
                            )
                          }
                        )
                      }
                    ) : /* @__PURE__ */ r(
                      g,
                      {
                        vertical: !0,
                        className: a.columnsList,
                        children: Je.map(
                          (e) => /* @__PURE__ */ A(
                            g,
                            {
                              align: "center",
                              gap: 8,
                              className: a.columnOption,
                              children: [
                                /* @__PURE__ */ r(
                                  Ve,
                                  {
                                    className: a.columnPanelCheckbox,
                                    checked: ee.includes(
                                      e.id
                                    ),
                                    onChange: () => {
                                      Xe(
                                        e.id
                                      );
                                    },
                                    "aria-label": e.label
                                  }
                                ),
                                /* @__PURE__ */ r(
                                  D.Text,
                                  {
                                    className: a.columnLabel,
                                    children: e.label
                                  }
                                )
                              ]
                            },
                            e.id
                          )
                        )
                      }
                    )
                  ]
                }
              )
            }
          ),
          L === "filters" && /* @__PURE__ */ r(
            g,
            {
              vertical: !0,
              className: a.filtersSidebar,
              children: /* @__PURE__ */ A(
                g,
                {
                  vertical: !0,
                  className: a.filtersBody,
                  children: [
                    /* @__PURE__ */ r(
                      g,
                      {
                        align: "center",
                        gap: 8,
                        className: a.filtersToolbar,
                        children: /* @__PURE__ */ r(
                          Le,
                          {
                            allowClear: !0,
                            prefix: /* @__PURE__ */ r(qe, {}),
                            placeholder: "Search filters...",
                            value: ae,
                            onChange: (e) => {
                              oe(
                                e.target.value
                              );
                            },
                            className: a.filtersSearch
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ r(
                      g,
                      {
                        vertical: !0,
                        className: a.filtersCollapseScroll,
                        children: /* @__PURE__ */ r(
                          Kt,
                          {
                            ghost: !0,
                            expandIconPlacement: "end",
                            items: yt.map(
                              (e) => ({
                                key: e.id,
                                label: e.label,
                                children: /* @__PURE__ */ r(
                                  Lr,
                                  {
                                    fieldID: e.id,
                                    label: e.label,
                                    columnDef: e.columnDef,
                                    value: w[e.id] || "",
                                    onChange: (o) => {
                                      xe(
                                        e.id,
                                        o
                                      );
                                    }
                                  }
                                )
                              })
                            )
                          }
                        )
                      }
                    )
                  ]
                }
              )
            }
          ),
          L === "configuration" && /* @__PURE__ */ r(
            g,
            {
              vertical: !0,
              className: a.filtersSidebar,
              children: /* @__PURE__ */ A(
                g,
                {
                  vertical: !0,
                  className: a.filtersBody,
                  children: [
                    /* @__PURE__ */ r(D.Text, { strong: !0, children: "Configuration" }),
                    /* @__PURE__ */ A(g, { vertical: !0, gap: 12, children: [
                      /* @__PURE__ */ r(D.Text, { children: "Layout Configuration" }),
                      /* @__PURE__ */ r(
                        ue,
                        {
                          icon: /* @__PURE__ */ r(rt, {}),
                          onClick: () => {
                            te.current = !1, He(
                              x
                            ), He(
                              `${x}:column-widths`
                            ), Y([
                              ...p
                            ]), Be(
                              x,
                              {}
                            ), Ae(
                              x,
                              Ie
                            ), v == null || v(
                              Ie
                            );
                          },
                          children: "RESET"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ A(g, { vertical: !0, className: a.rightTabsBar, children: [
            /* @__PURE__ */ A(
              g,
              {
                vertical: !0,
                align: "center",
                className: `${a.tabItem} ${L === "columns" ? a.activeTab : ""}`,
                onClick: () => {
                  X(
                    (e) => e === "columns" ? null : "columns"
                  );
                },
                children: [
                  /* @__PURE__ */ r(
                    er,
                    {
                      className: a.tabIcon
                    }
                  ),
                  /* @__PURE__ */ r(D.Text, { className: a.tabText, children: "Columns" })
                ]
              }
            ),
            /* @__PURE__ */ A(
              g,
              {
                vertical: !0,
                align: "center",
                className: `${a.tabItem} ${L === "filters" ? a.activeTab : ""}`,
                onClick: () => {
                  X(
                    (e) => e === "filters" ? null : "filters"
                  );
                },
                children: [
                  /* @__PURE__ */ r(
                    tr,
                    {
                      className: a.tabIcon
                    }
                  ),
                  /* @__PURE__ */ r(D.Text, { className: a.tabText, children: "Filters" })
                ]
              }
            ),
            /* @__PURE__ */ A(
              g,
              {
                vertical: !0,
                align: "center",
                className: `${a.tabItem} ${L === "configuration" ? a.activeTab : ""}`,
                onClick: () => {
                  X(
                    (e) => e === "configuration" ? null : "configuration"
                  );
                },
                children: [
                  /* @__PURE__ */ r(
                    rr,
                    {
                      className: a.tabIcon
                    }
                  ),
                  /* @__PURE__ */ r(D.Text, { className: a.tabText, children: "Configuration" })
                ]
              }
            )
          ] })
        ] }),
        I && /* @__PURE__ */ A(g, { vertical: !0, className: a.sidePanel, children: [
          /* @__PURE__ */ A(
            g,
            {
              align: "center",
              justify: "space-between",
              className: a.sidePanelHeader,
              children: [
                /* @__PURE__ */ r(D.Text, { strong: !0, children: s.mode === "create" ? "Create" : Re === "read" ? "View" : "Edit" }),
                /* @__PURE__ */ r(
                  ue,
                  {
                    type: "text",
                    icon: /* @__PURE__ */ r(nr, {}),
                    onClick: Ne
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ r(g, { vertical: !0, className: a.sidePanelBody, children: Re === "create" ? /* @__PURE__ */ r(
            et,
            {
              entity: t,
              mode: "create",
              showEditButton: z,
              onSaved: (e) => {
                const o = l ?? t;
                if (t === "patient_case") {
                  m == null || m(), J(
                    o,
                    null
                  ), Ne();
                  return;
                }
                (e == null ? void 0 : e.id) !== null && (e == null ? void 0 : e.id) !== void 0 && J(
                  o,
                  {
                    id: String(e.id),
                    mode: Ce
                  }
                );
              }
            }
          ) : Te.isLoading && !T ? /* @__PURE__ */ r(
            g,
            {
              flex: 1,
              justify: "center",
              align: "center",
              className: a.loadingWrap,
              children: /* @__PURE__ */ r(Ht, { size: "large" })
            }
          ) : T && /* @__PURE__ */ r(
            et,
            {
              entity: t,
              data: T,
              mode: Re ?? s.mode,
              showEditButton: z,
              onArchived: () => {
                m == null || m(), Ne();
              },
              onSaved: (e) => {
                const o = l ?? t;
                if (t === "patient_case") {
                  m == null || m(), J(
                    o,
                    null
                  ), Ne();
                  return;
                }
                (e == null ? void 0 : e.id) !== null && (e == null ? void 0 : e.id) !== void 0 && J(
                  o,
                  {
                    id: String(
                      e.id
                    ),
                    mode: Ce
                  }
                );
              }
            }
          ) })
        ] })
      ] })
    ] });
  }
);
ut.displayName = "TableView";
const hn = "_root_1yw3w_6", gn = "_content_1yw3w_11", bn = "_tableSection_1yw3w_16", Me = {
  root: hn,
  content: gn,
  tableSection: bn
}, Sn = ({
  entity: t,
  entityColOverride: l,
  customColumnDefs: n,
  customColumnDefsPosition: u,
  presetFilters: i,
  scope: c,
  onRowClick: S,
  getRowContextMenuItems: N,
  showAddButton: P = !0,
  showEditButton: w = !0,
  entityDefOverride: _,
  initialSortOverride: d,
  buildBaseListUrl: v,
  rowSelectionMode: m,
  tableActions: U,
  toolbarExtra: O
}) => {
  const z = Ke(), $ = hr((h) => h.access), q = Pe(), M = _ ?? q.data[t], y = Ft(), R = b(() => {
    if (c && (y != null && y.parentID)) {
      const h = String(y.parentID);
      if (h)
        return `${y.parent}-${h}-${c.split("-").pop()}`;
    }
    return c;
  }, [c, y == null ? void 0 : y.parent, y == null ? void 0 : y.parentID]), s = b(() => {
    const h = (i == null ? void 0 : i.filters) || {}, G = {};
    for (const [ve, ye] of Object.entries((y == null ? void 0 : y.links) || {}))
      G[`${ve}_id`] = ye;
    const ie = { ...h, ...G };
    return Object.keys(ie).length === 0 ? i : { filters: ie };
  }, [i == null ? void 0 : i.filters, y == null ? void 0 : y.links]), I = ot((h) => h.getFilters), T = ot((h) => h.setFilters), f = b(() => `table-view:${t}`, [t]), L = Z(
    (h) => {
      var G;
      return ((G = h.tablePreferencesByKey[f]) == null ? void 0 : G.sorting) ?? Ie;
    }
  ), X = b(() => {
    if (L.length > 0)
      return tt(L);
    if (d !== void 0)
      return d;
    const h = Jt(M);
    return h.length > 0 ? h : void 0;
  }, [M, d, L]), j = b(
    () => v ? { buildBaseListUrl: v } : void 0,
    [v]
  ), Y = b(() => {
    const h = R ? I(R) : {};
    return Object.keys(h).length > 0 ? h : (s == null ? void 0 : s.filters) || {};
  }, [R, I, s == null ? void 0 : s.filters]), [Q, ne, ae, oe] = xt(
    t,
    {
      initialFilters: Y,
      initialLimit: 100,
      initialSort: X,
      params: j,
      queryOptions: {
        retry: 3,
        retryDelay: 1e3
      }
    }
  ), me = b(() => {
    const h = oe.sort;
    if (!h)
      return L;
    const G = Array.isArray(h) ? h : [h];
    return Xt(G);
  }, [oe.sort, L]), { setFilters: pe, setSort: x } = ae, fe = F(
    (h) => {
      pe(h), R && T(R, h);
    },
    [pe, R, T]
  ), ce = F(
    (h) => {
      x(tt(h));
    },
    [x]
  ), te = b(
    () => ({
      ...Q,
      pagination: ne,
      listParams: oe
    }),
    [
      Q.data,
      Q.isLoading,
      Q.isFetching,
      Q.error,
      ne.page,
      ne.limit,
      ne.hasNextPage,
      ne.canGoPrev,
      oe
    ]
  ), re = b(() => {
    if (!(!P || !Mt(t)))
      return () => void z({
        to: ".",
        search: {
          mode: "create"
        }
      });
  }, [P, t, $, z]);
  return /* @__PURE__ */ A(g, { vertical: !0, className: Me.root, children: [
    !M && /* @__PURE__ */ r(it, { type: "warning", title: "Entity not found", showIcon: !0 }),
    M && /* @__PURE__ */ r(g, { vertical: !0, gap: 12, className: Me.content, children: /* @__PURE__ */ r("div", { className: Me.tableSection, children: /* @__PURE__ */ r(
      ut,
      {
        entity: t,
        scope: R ?? t,
        entityColOverride: l,
        customColumnDefs: n,
        customColumnDefsPosition: u,
        tableData: te,
        onRowClick: S,
        getRowContextMenuItems: N,
        entityDefOverride: _,
        filters: oe.filters,
        onFilterChange: fe,
        onSortChange: ce,
        sorting: me,
        refresh: () => {
          ae.refresh();
        },
        loading: Q.isFetching,
        onAddNew: re,
        showEditButton: w,
        rowSelectionMode: m,
        tableActions: U,
        toolbarExtra: O
      },
      t
    ) }) })
  ] });
}, xn = ({
  entity: t,
  basePath: l,
  paramName: n,
  scope: u,
  entityColOverride: i,
  customColumnDefs: c,
  customColumnDefsPosition: S,
  toolbarExtra: N
}) => {
  const P = Ke(), w = Pe().data[t], _ = je((O) => O.addOpenTab), d = Bt(Vt), v = b(() => {
    if (u && (d != null && d.parentID)) {
      const O = String(d.parentID);
      if (O)
        return `${d.parent}-${O}-${u.split("-").pop()}`;
    }
    return u ?? t;
  }, [u, d == null ? void 0 : d.parent, d == null ? void 0 : d.parentID, t]), m = b(() => {
    if (!(d != null && d.links)) return;
    const O = {};
    for (const [z, $] of Object.entries(d.links))
      O[`${z}_id`] = $;
    return { filters: O };
  }, [d == null ? void 0 : d.links]), U = F(
    (O) => {
      _(
        v,
        O.id,
        dt(w.ui.nameTemplate, O)
      ), P({
        to: `${l}/$${n}`,
        params: { [n]: O.id }
      });
    },
    [_, v, t, P, l, n]
  );
  return /* @__PURE__ */ r(
    Sn,
    {
      onRowClick: U,
      entity: t,
      scope: v,
      presetFilters: m,
      showAddButton: !1,
      entityColOverride: i,
      customColumnDefs: c,
      customColumnDefsPosition: S,
      toolbarExtra: N
    }
  );
};
export {
  Sn as L,
  xn as T,
  ut as a,
  Sr as u
};
